module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABXklEQVQoU2WSPy8DcRjHP8/RgU14Ff6NIhG96yESq4Q3YBIMVSEsJu6UgcRiMxm8iKvQImKrP00MVmFro6d698hdSYtn+g3P5/f9PE8ewXKfUP3AD2yuN16wdnsgeAXOKFenuN18p6UEa3sWNU4QLRGESc7XX7HcZWAXpUAtMc5luvrDSPxIOjOInIA+NpOcDEgWuKBcnfxJagCtkHBPENhxkumkEdlDOaeWmIySmkAEje5MY+gp6APSbpLLvP3S6+ywfwMRlNqeRo1j4Bmqw+Q2K1juAsoBqPcfSDoDGOIBShD0NpawM4fqEULhj1J2ECP0EEKop8htFDGdRUSi368o+2OtQw9g4IEoGClyK0VMdx7hEPQa/PFIrwGMOH0k5CzW+FSL/NodpruEsI/qDRXfaq7VyvZD6KGE1NX+1yy+HQ/+XYLplhC6oG7HzkNb3XS2vcUanzJBfrXcehpf8JalvcgpqW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjt.png
// module id = gse1
// module chunks = 1